module.exports = __webpack_public_path__ + "img/asymmetry-right.834264e1.svg";